'use client'

import { useContext, useEffect, useState } from 'react'
import ClickAwayListener from 'react-click-away-listener'
import { ConfigContext, useTranslation } from '../../../context/ConfigContext'
import OrderProducts, { SortByChoice } from '../FilterProductFormMobile/OrderProducts'
import Icon from '../../Icon/Icon'
import { Icons } from '../../Icon/constants'

type FilterProductFormMenuOrderByProps = {
  sortBy: SortByChoice

  onChange: (value: SortByChoice) => void
}

const FilterProductFormMenuOrderBy = ({ sortBy, onChange }: FilterProductFormMenuOrderByProps) => {
  const { storeConfig } = useContext(ConfigContext)
  const [open, setOpen] = useState(false)
  const t = useTranslation()

  useEffect(() => {
    setTimeout(() => setOpen(false), 800)
  }, [sortBy])

  return (
    <>
      {storeConfig.display_prices === 1 && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <div className={`filter-product-form-menu-orderby ${open ? 'open' : ''}`}>
            <button
              onClick={() => setOpen((prevState) => !prevState)}
              type='button'
              className='filter-product-form-menu-orderby-button'>
              <span>{t('SORT BY', {}, true)}</span> <Icon iconName={Icons.FILTER_LIST} />
            </button>
            <div className='filter-product-form-orderby'>
              <OrderProducts sortBy={sortBy} onChange={(value) => onChange(value)} />
            </div>
          </div>
        </ClickAwayListener>
      )}
    </>
  )
}

export default FilterProductFormMenuOrderBy
